import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import UI Components
import ConfirmationModal from 'components/common/Modals/ConfirmationModal';
// Import Constants
import { l, ActionsIcons, ModalsClassNames, ModalsActions } from 'constants/common';
// Import Hooks
import useRequest from 'hooks/UseRequest';
import useCancelableRequests from 'hooks/UseCancelableRequests';
// Import Services
import { CommunicationHttpService } from 'services/http';

const CommunicationActionsModals = ({
    isResendModalOpenedState,
    onCloseModalHandler,
    modalsStateSetDict,
    openedModalData,
}) => {
    const { CommunicationId, ClientId } = openedModalData;
    const { t } = useTranslation();
    const { doPostRequest } = useRequest();
    const [isLoading, setIsLoading] = useState(false);

    const { sendCommunicationRequest } = useCancelableRequests({
        sendCommunicationRequest: CommunicationHttpService.resendCommunication,
    });

    const resend = () => {
        setIsLoading(true);
        doPostRequest(sendCommunicationRequest.request, {
            queryString: { communicationId: CommunicationId },
            isShowError: false,
        }).then(({ AlertMessage, AlertType, IsCanceled }) => {
            // Aborted on unmount: no toaster
            if (IsCanceled) return;
            onCloseModalHandler(
                modalsStateSetDict.resendCommunication.key,
                ModalsActions.RESEND,
                AlertType,
                AlertMessage,
            );
            setIsLoading(false);
        });
    };

    return (
        <>
            {isResendModalOpenedState && (
                <ConfirmationModal
                    onOk={resend}
                    onCancel={() => onCloseModalHandler(modalsStateSetDict.resendCommunication.key)}
                    isVisibleModal={isResendModalOpenedState}
                    titleText={t(l.ResendTittle)}
                    isLoading={isLoading}
                    iconType={ActionsIcons.Resend}
                    actionLabel={t(l.Send)}
                    className={ModalsClassNames.Start}
                    questionLabel={t(l.AreYouSureYouWantToSendCommunicationToClient, {
                        clientId: `"${ClientId}"`,
                    })}
                />
            )}
        </>
    );
};

CommunicationActionsModals.propTypes = {
    isResendModalOpenedState: PropTypes.bool.isRequired,
    onCloseModalHandler: PropTypes.func.isRequired,
    modalsStateSetDict: PropTypes.object.isRequired,
    openedModalData: PropTypes.any.isRequired,
};

export default memo(CommunicationActionsModals);
